module.exports = __webpack_public_path__ + "static/media/gal-10.6423b876.jpeg";